// Fallback defaults so the site renders instantly before /api/settings loads.
// The backend merges these same defaults, so this only prevents empty flashes.
export const SITE_DEFAULTS = {
  home: {
    hero_eyebrow: "Precision Drum Hardware",
    hero_line1: "The Backbone",
    hero_line2: "Of Your",
    hero_line3_accent: "Rhythm",
    hero_description:
      "Die-cast hoops, quick-release locks, self-lubricating rods and milled keys — engineered for drummers who refuse to compromise on stage.",
    hero_image:
      "https://images.unsplash.com/photo-1738239653643-a17c39e88dd5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    marquee: ["Precision Hardware", "Built For Stage", "No Compromise", "Rimshot Ready"],
    features: [
      { title: "Engineered", body: "CNC-milled and die-cast components with tolerances measured in microns." },
      { title: "Aggressive", body: "Sharp rimshots, cutting attack and a response that keeps up with your fastest fills." },
      { title: "Reliable", body: "Zero-slip memory locks and self-lubricating rods hold tune show after show." },
    ],
    featured_eyebrow: "01 / The Gear",
    featured_title: "Featured Hardware",
    artists_eyebrow: "02 / The Players",
    artists_title: "Powered by\ndrummers who\nhit hard.",
    artists_description:
      "From arena tours to studio sessions, the world's most demanding drummers rely on GAVRA hardware to stay locked in — night after night.",
  },
  about: {
    eyebrow: "Our Manifesto",
    title: "The GAVRA",
    title_accent: "Manifesto",
    hero_image:
      "https://images.unsplash.com/photo-1738239477356-ca1a207e1b4a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    intro:
      "GAVRA exists for one reason — to be the invisible backbone of every drummer's sound. The parts you never think about until they fail. We make sure they never do.",
    chapters: [
      { n: "01", title: "Obsessed with Precision", body: "Every GAVRA component starts on a CAD screen and ends under a micrometer." },
      { n: "02", title: "Built for Aggression", body: "Drummers hit hard. Our hardware is engineered to take a beating tour after tour." },
      { n: "03", title: "Zero Compromise", body: "We don't cut corners on materials, finishes or the details you never see." },
      { n: "04", title: "Made for the Stage", body: "Designed for fast tear-downs, repeatable setups and zero slippage." },
    ],
    cta_title: "Ready to upgrade\nyour hardware?",
    cta_primary_label: "Shop hardware",
    cta_primary_url: "/products",
    cta_secondary_label: "Contact us",
    cta_secondary_url: "/contact",
  },
  contact: {
    eyebrow: "Say Hello",
    title: "Get In\nTouch",
    description:
      "Dealer enquiries, artist relations, product support or just to talk drums — drop us a line and a human will get back to you.",
    email: "contact@gavrahardware.com",
    web: "www.gavrahardware.com",
  },
  footer: {
    eyebrow: "Precision Drum Hardware",
    headline: "Built for the backbone of your rhythm.",
    email: "contact@gavrahardware.com",
    web: "www.gavrahardware.com",
    copyright: "GAVRA Hardware. All rights reserved.",
    tagline: "Precision · Aggression · No Compromise",
  },
  socials: [
    { label: "Instagram", icon: "instagram", href: "https://www.instagram.com/gavrahardware" },
    { label: "Facebook", icon: "facebook", href: "https://www.facebook.com/gavrahardware" },
    { label: "YouTube", icon: "youtube", href: "https://www.youtube.com/@GavraHardware" },
  ],
};
